import getCharts from '../getCharts'
import { EmployeeLeaveCRUD } from '../../constants/api.config'
import { toLeaveCalendarKey } from '../../components/shared/leaveCalendarDateUtils'

export default async function SaveLeave(params = {}) {
    let payload = {}
    // Leave dates are calendar days, not instants.  Keep the API payload as an
    // unambiguous date-only value so either the provider or admin timezone
    // cannot turn (for example) July 29 into July 28.
    const normalizeDate = (value) => toLeaveCalendarKey(value) || ''

    if (params && typeof params === 'object' && !Array.isArray(params)) {
        payload = {
            mode: params.mode,
            leaveId: params.leaveId,
            LeaveId: params.leaveId,
            employeeId: params.employeeId,
            EmployeeId: params.employeeId,
            employeeName: params.employeeName,
            EmployeeName: params.employeeName,
            employeeCountry: params.employeeCountry,
            EmployeeCountry: params.employeeCountry,
            leaveType: params.leaveType,
            LeaveType: params.leaveType,
            leaveBalanceDays: params.leaveBalanceDays,
            LeaveBalanceDays: params.leaveBalanceDays,
            fromDate: normalizeDate(params.fromDate),
            FromDate: normalizeDate(params.fromDate),
            toDate: normalizeDate(params.toDate),
            ToDate: normalizeDate(params.toDate),
            status: params.status,
            Status: params.status,
            comments: params.comments,
            Comments: params.comments,
            reason: params.comments,
            Reason: params.comments,
            reasonForLeave: params.comments,
            ReasonForLeave: params.comments,
            leaveReason: params.comments,
            LeaveReason: params.comments,
            remark: params.remark,
            Remark: params.remark,
            compOffDates: params.compOffDates || params.compensationDate || params.CompOffDates || '',
            CompOffDates: params.compOffDates || params.compensationDate || params.CompOffDates || '',
        }
    }

    try {
        const res = await getCharts(EmployeeLeaveCRUD, payload)
        return res.data
    } catch (error) {
        console.error('SaveLeave API failed:', error)
        return error
    }
}
